import { useEffect, useState } from "react";
import ConsultationModal from "../../modal/ConsultationModals";
import { ChangeConsultationButton } from "./StyledComponents";
import useInputState from "../inputState/useInputState";
import { useTranslation } from "react-i18next";
import useCalendar from "../context/useCalendar";

const ChangeConsultation = () => {
    const { inputCallbacks } = useCalendar();
    const { modalOpen, version } = useInputState();
    const [isOpen, setOpen] = useState(modalOpen);
    const { t } = useTranslation();
    const handleClick = () => {
        inputCallbacks.onChangeConsultationButtonClick && inputCallbacks.onChangeConsultationButtonClick()
        setOpen(true)
    };

    useEffect(() => {
        setOpen(modalOpen);
    }, [modalOpen, version]);

    return (
        <>
            <ChangeConsultationButton onClick={handleClick}>
                {t("change_consultation")}
            </ChangeConsultationButton>
            {isOpen && <ConsultationModal setOpen={setOpen} open={isOpen} />}
        </>
    );
};

export default ChangeConsultation;
